export default __webpack_public_path__ + "static/media/386.9c86ff91.gif";